import {
  BankAccountStatusEnum,
  PaymentAccountTransferMethod,
} from '@graphql/react-apollo'
import type { BankAccountFragmentFragment } from '@graphql/react-apollo'

// Method-agnostic account classification, shared across the card + ach linking
// flows and each location's destination/state resolution. One code path so the
// wallet and cash-advance classify accounts identically.

// transferMethod's raw case isn't guaranteed (the BE upcases it before
// comparing), so compare case-insensitively against the enum values.
export function matchesMethod(
  account: BankAccountFragmentFragment,
  method: PaymentAccountTransferMethod,
): boolean {
  return account.transferMethod?.toUpperCase() === method
}

// LINKED is the authoritative "usable" signal — NOT deleted_at, which persists
// through relinks and can't be trusted (verified in atm-backend: relink logic
// keys off status, and a delete→relink leaves deleted_at populated on the
// now-LINKED account).
export function isLinked(account: BankAccountFragmentFragment): boolean {
  return account.status === BankAccountStatusEnum.Linked
}

// The usable account for a transfer method = the LINKED one of that method.
export function findLinkedAccount(
  accounts: BankAccountFragmentFragment[],
  method: PaymentAccountTransferMethod,
): BankAccountFragmentFragment | undefined {
  return accounts.find(
    (account) => matchesMethod(account, method) && isLinked(account),
  )
}
